import React from 'react';
import { sanitizeMarkup } from '../../util/sanitize/sanitize-html';
import { formatRateRange } from '../seeker/details/New_UI/Components/util';

const PayRateForJobDetails = ({ payRate }: any) => {
    return (
        <div>
            <div className='mb-4'>
                {payRate?.salary && (
                    <div >
                        <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">{(payRate?.commission || payRate?.additionalBenifits) ? `Salary + ${(payRate?.additionalBenifits === "empBO") ? "Bonus" : "Commision"}` : "Salary"}</p>
                        <p className='text-instant-teams-blue-L1 my-2'>  {(payRate?.commission || payRate?.additionalBenifits) ? ` ${(payRate?.additionalBenifits === "empBO") ? "This position offers a base salary plus additional bonus opportunities." : "This position offers a base salary plus additional commission opportunities."}` : ""} </p>
                        {(payRate?.commission || payRate?.additionalBenifits) && <p className='text-instant-teams-blue-L1 font-semibold text-lg mt-2 '>
                            Salary
                        </p>}
                        {!(payRate?.commission || payRate?.additionalBenifits) && <p className='text-instant-teams-blue-L1 my-2 '>
                            This position offers a fixed annual salary.
                        </p>}
                        <p className="text-gray-500 text-[14px]">{formatRateRange("salary", payRate?.salary)}</p>
                    </div>
                )}
                {payRate?.hourly && (
                    <div >
                        <p className="font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#15415E]">{(payRate?.commission || payRate?.additionalBenifits) ? `Salary + ${(payRate?.additionalBenifits === "empBO") ? "Bonus" : "Commision"}` : "Salary"}</p>
                        <p className='text-instant-teams-blue-L1 my-2'>  {(payRate?.commission || payRate?.additionalBenifits) ? ` ${(payRate?.additionalBenifits === "empBO") ? "This position offers a base salary plus additional bonus opportunities." : "This position offers a base salary plus additional commission opportunities."}` : ""} </p>
                        {(payRate?.commission || payRate?.additionalBenifits) && <p className='text-instant-teams-blue-L1 font-semibold text-lg mt-2 '>
                            Salary
                        </p>}
                        {!(payRate?.commission || payRate?.additionalBenifits) && <p className='text-instant-teams-blue-L1 my-2 '>
                            This position offers an hourly wage.
                        </p>}
                        <p className="text-gray-500 text-[13px]">{formatRateRange("hoursPerWeek", payRate?.hourly, true)}/ Hr</p>
                    </div>
                )}
            </div>

            {
                payRate?.commission && <>
                    <div className=''>
                        <h1 className={`${((payRate?.salary || payRate?.hourly)) ? "text-instant-teams-blue-L1 font-semibold text-lg " : " font-[Gilroy-SemiBold] font-[400] text-[20px] leading-[24.5px] text-[#13374f]"}`}>
                            {(payRate?.commission || payRate?.additionalBenifits) ? payRate?.additionalBenifits === "empBO" ? "Bonus" : (!payRate?.salary && !payRate?.hourly) ? "Commission Only" : "Commission" : null}

                        </h1>
                        {(!payRate?.salary && !payRate?.hourly) && <p className='text-instant-teams-blue-L1  mt-2 mb-1'>
                            This is a commission-only role with earnings based on performance.
                        </p>}
                    </div>
                    <p className="text-gray-500 mb-6 text-[13px] ">
                        <div
                            className="dangerously text-[13px] "
                            dangerouslySetInnerHTML={sanitizeMarkup(
                                payRate.commission
                            )}
                        ></div>

                    </p>

                </>
            }
        </div>
    );
}

export default PayRateForJobDetails;
